// Libs
import React from 'react';
import styled, { css } from 'styled-components';
// Hooks
import useTheme from 'hooks/useTheme';
// Components
import IconButton from '@mui/material/IconButton';
import Icon from './Icon';

const Button = styled(IconButton)`
	${props =>
		props.shadow &&
		css`
			-webkit-box-shadow:
				-10px 0px 13px -7px #000000,
				10px 0px 13px -7px #000000,
				5px 5px 15px 5px rgba(0, 0, 0, 0);
			box-shadow:
				-10px 0px 13px -7px #000000,
				10px 0px 13px -7px #000000,
				5px 5px 15px 5px rgba(0, 0, 0, 0);
		`}
`;

const PDFIcon = ({ button, onClick, shadow }) => {
	const { theme } = useTheme();
	const fill = theme._inactiveColor;

	if (button) {
		return (
			<Button shadow={shadow} onClick={onClick}>
				<Icon fill={fill} />
			</Button>
		);
	}

	return <Icon fill={fill} onClick={onClick} />;
};

export default PDFIcon;
